// extracted by mini-css-extract-plugin
module.exports = {"brikkFooter":"styles_brikkFooter__oOq9h"};